import { timefarm, laborx, timex, paymentx, audt } from 'src/data/products'

export default {
  data () {
    return {
      date: new Date(),
      products: [timefarm, laborx, timex, paymentx, audt]
    }
  },
  methods: {
    onClickLogo () {
      if (this.$route.name === 'Landing') {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }
  }
}
